import { Articles } from "../types/article";
import {
  ArticleListItemContainer,
  ArticleListItemImage,
  FurnitureSetWrapperInGroup,
  GreyBoxWithText,
} from "../styles/styles";
import { isLocalCombinationArticle } from "../Helpers/articleHelpers";
import FurnitureSet from "../../../../../coworker-app/src/assets/svg/furniture-set.svg";
import { ArticleType } from "@coworker/types/lib/tasks/constants";

const NumberOfImagesToShow = 3;

interface ArticlesImagesOverviewProps {
  articles: Articles;
}

export const ArticlesImagesOverview = ({
  articles,
}: ArticlesImagesOverviewProps) => {
  const numberOfImagesToShow =
    articles.length >= NumberOfImagesToShow
      ? NumberOfImagesToShow
      : articles.length;
  const numberOfImagesNotShown = articles.length - numberOfImagesToShow;

  return (
    <ArticleListItemContainer>
      {articles
        .slice(0, numberOfImagesToShow)
        .map(({ imageSmall, id, productArticleType }, index) =>
          isLocalCombinationArticle(productArticleType as ArticleType) ? (
            <FurnitureSetWrapperInGroup key={`${id}-${index}`}>
              <img
                src={FurnitureSet}
                alt="Furniture Set"
                style={{ width: "24px", height: "24px" }}
              />
            </FurnitureSetWrapperInGroup>
          ) : (
            <ArticleListItemImage
              key={`${id}-${index}`}
              src={imageSmall ?? ""}
            />
          )
        )}
      {numberOfImagesNotShown > 0 && (
        <GreyBoxWithText
          key={`Images not shown ${numberOfImagesNotShown}`}
        >{`+${numberOfImagesNotShown}`}</GreyBoxWithText>
      )}
    </ArticleListItemContainer>
  );
};
